import { getProductName } from 'Common/config';
import { configSelector } from '../configuration';

export function productNameSelector(state = {}) {
  const config = configSelector(state);
  return getProductName(config);
}
